import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const ReferenceImagesOuterContainer = styled.div`
  position: relative;
  width: 108px;
  height: 108px;
  flex-shrink: 0;

  .loading-spinner {
    position: absolute;
  }
`

export const RemoveImageIconWrapper = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  transition: all 0.2s ease-in-out;

  &:hover {
    svg {
      fill: ${COLORS.secondarySemiDark};
    }
  }
`
